var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-popup" }, [
    _c("div", { staticClass: "head" }, [
      _c("div", { staticClass: "main-title" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.locales("payment_popup_title")) + "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "body" },
      [
        _c("payment-plans-widget", {
          attrs: {
            plans: _vm.plans,
            "users-count-list": _vm.dropdownUsersSelection,
            selected: _vm.selectedCount,
            "is-annual": _vm.isAnnual,
            "is-popup": true,
          },
          on: {
            toggleAnnual: _vm.toggleAnnual,
            buyPlanClick: _vm.buyPlanClick,
            upgradePlanClick: _vm.upgradePlanClick,
            changeUserCount: _vm.changeUserCount,
          },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "contact-footer",
          domProps: {
            innerHTML: _vm._s(_vm.locales("payment_popup_contact_footer")),
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }